export default function stringifyError(err, filter, space = '  ') {
  const plainObject = {};

  Object.getOwnPropertyNames(err).forEach(function(key) {
    plainObject[key] = err[key];
  });

  return JSON.stringify(plainObject, filter, space);
}
